<template>
    <div>
        <div class="card-panel" v-if="$G_DEVICE_CFG.area!='TRUE'">
            <div class="card-body">
                <div class="row">
                    <h4 class="col-xs-9">Filink</h4>
                    <el-switch v-model="FilinkEnabele" @change="setFilinkEnabele" class="col-xs-3 Filink-btn" 
                    :disabled="$G_DEVICE_CFG.isReadOnly || $G_DEVICE_CFG.isSubRouter"></el-switch>
                </div>
                <div class="line-header"></div>
                <!-- 主路由/子路由选择 -->
                <div v-if="deviceType === 0 && FilinkEnabele" class="home-btn Filink-conter">
                    <el-button @click="setMainDec">Main Router</el-button>
                    <el-button @click="setSubDec">Subrouter</el-button>
                </div>
                <!-- 主路由模式，显示子路由列表 -->
                <div v-if="deviceType === 1 && FilinkEnabele">
                    <div v-if="childDevicelist.length">
                        <div class="row form-group boder-bottom click-topo" 
                        @click="isTopoShow = true"
                        v-for="(cDevice,index) in childDevicelist" :key="cDevice.Mac">
                            <div class="col-xs-3">
                                <img src="@/assets/img/home/Group_34.png">
                            </div>
                            <div class="col-xs-5">
                                <p class="wifi-title">Subrouter-{{index + 1}}</p>
                                <p class="wifi-info">{{cDevice.ip}}</p>
                                <p class="wifi-info">{{cDevice.Mac}}</p>
                            </div>
                            <div class="col-xs-4 row subDev-speed">
                                <div class="col-xs-6">
                                    <i class="glyphicon glyphicon-arrow-up upload-color" aria-hidden="true"></i> 
                                </div>
                                <div class="col-xs-6 ">
                                    <i class="glyphicon glyphicon-arrow-down download-color" aria-hidden="true"></i>
                                </div>
                                <div class="col-xs-6"> {{byteToKbOrMb(cDevice.DownSpeed)}}</div>
                                <div class="col-xs-6"> {{byteToKbOrMb(cDevice.UpSpeed)}}</div>
                            </div>
                        </div>
                         <el-alert
                            v-if="!$isAis"
                            :closable="false"
                            title="How do I revert to standard mode"
                            type="warning"
                            description="If you want to restore subrouter mode to standard mode, Suggest long press the subrouter reset button to restore."
                            show-icon>
                        </el-alert>
                    </div>
                    <div class="Filink-conter" v-else>
                        <h4><i class="el-icon-refresh"></i> Subrouter not found</h4>
                    </div>
                </div>
                <!-- 子路由显示信息 -->
                <div v-if="deviceType === 2 && FilinkEnabele" class="Filink-conter Filink-child-text">
                    <h4 style="color: #8DC63F;">Device is Subrouter mode</h4>
                    <p v-if="subDevConnect">Filink networking success！Connected main router MAC: {{manDevMac}}</p>
                    <p v-else>Please click the button below to set up the network.</p>
                </div>
                <el-alert
                    v-if="!$isAis && deviceType === 2 && FilinkEnabele" 
                    :closable="false"
                    title="How do I revert to standard mode"
                    type="warning"
                    description="If you want to restore subrouter mode to standard mode, Suggest long press reset button to restore."
                    show-icon>
                </el-alert>
                
            </div>
            <div class="card-footer border-top home-btn" v-if="deviceType === 1 && FilinkEnabele">
                <el-button icon="el-icon-plus" @click="addChildDevice" :disabled="$G_DEVICE_CFG.isReadOnly">Add Subrouter</el-button>
            </div>
            <div class="card-footer border-top home-btn" v-if="deviceType === 2 && FilinkEnabele">
                <el-button icon="el-icon-plus" @click="showNetMode = true" :disabled="$G_DEVICE_CFG.isReadOnly">Join the Filink network</el-button>
            </div>
        </div>
        <!-- 添加子路由弹窗 -->
        <el-dialog
            title="Add Subrouter"
            :visible.sync="addDevice"
            :close-on-click-modal="false"
            width="30%"
            center>
            <p class="add-title">Accessed device:<span> {{addNewSubDev.length}} </span>station</p>
            <div class="add-content-end" v-if="addNewSubDev.length">
                <div class="add-subdev" v-for="cDevice in addNewSubDev" :key="cDevice.Mac">
                    <img src="@/assets/img/home/Group_34.png">
                    <p class="wifi-info">{{cDevice.Mac}}</p>
                    <p class="wifi-info">{{cDevice.ip}}</p>
                </div>
            </div>
            
            <div class="add-content" 
                v-else
                v-loading="addLoading" 
                element-loading-text="Waiting for device access...">
                {{addRetText}}
            </div>
            <div class="add-help">
                <h4>Use WPS button to access</h4>
                <p>Press the WPS button of the subrouter more than 5s to connect to the Main Router,after that the WPS led of the subrouter will also start to blink quickly ,and starts to search for Main Router.</p>
                <div class="add-and">
                    <span class="add-hr"></span> <span> Or </span> <span class="add-hr"></span>
                </div>
                <h4>Use wired network to access</h4>
                <p>Insert the two ends of the network cable into the WAN port of the sub-router and the LAN port of the main router.</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addDevice = false">Cancel</el-button>
                <el-button type="primary" @click="addDevice = false" :disabled="childDevicelist.length < 1">Complete</el-button>
            </span>
        </el-dialog>

        <!--加入主路由弹窗弹窗 -->
        <el-dialog
            title="Join the Filink network"
            :visible.sync="addMainDialog"
            :close-on-click-modal="false"
            :before-close="addMainDevClose"
            width="35%"
            center>
            <div class="add-content" 
                v-loading="addLoading" 
                element-loading-text="Connecting to the primary routing device...">
                
                
                <div v-if="addMainDevStatus.status">
                    <h4 class="addSubDev-title">Filink networking success!</h4>
                    <p class="addSubDev-mac">Connected main router MAC: {{MainRouter.Mac}}</p>
                    <div class="addSubDev-foot">
                        please use<a :href="'http://' + addMainDevStatus.ip">{{addMainDevStatus.ip}}</a> revisit the current device management page
                    </div>
                </div>
                <div v-else>
                    {{addRetText}}
                </div>
            </div>
            <div class="add-help">
                <div v-if="subDevNetMode === 0">
                    <h4>Use wired network to access</h4>
                    <p>Insert the two ends of the network cable into the WAN port of the sub-router and the LAN port of the main router.</p>
                    <div class="add-and">
                        <span class="add-hr"></span> <span> And </span> <span class="add-hr"></span>
                    </div>
                </div>
                <div>
                    <h4>Access via WEB Filink button</h4>
                    <p>Log in to the main routing device, configure the device as the primary routing mode in the home Filink module, and then click the Add Sub-Routing button.</p>
                </div>
                
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addMainDevCancel">Cancel</el-button>
                <el-button type="primary" @click="addMainDevConfirm" :disabled="!addMainDevStatus.status">Complete</el-button>
            </span>
        </el-dialog>
        <!-- 选择子路由组网方式 -->
        <el-dialog
            title="Choose networking mode"
            :visible.sync="showNetMode"
            :close-on-click-modal="false"
            width="30%"
            center>
            <div class="home-btn subNetMode-conter">
                <el-button @click="chooseSubNetMode(0)">Wired networking</el-button>
                <el-button @click="chooseSubNetMode(3)">Wireless networking</el-button>
            </div>
        </el-dialog>
        <!-- 下挂设备 TOPO信息 -->
        <Topo :isShow="isTopoShow" :topoData="topoD" @closeTopo="closeTopoDialog"></Topo>
    </div>
</template>

<script>
    import devConfig from '@/devConfig'
    import Topo from './topo'
    export default {
        components:{Topo},
        data() {
            return {
                isTopoShow:false,
                topoD:{},
                FilinkEnabele: true,
                deviceType:0,
                addDevice:false,
                addLoading:false,
                addRetText:'',
                addMainDialog:false,
                subDevConnect:false,// 子路由模式下是否连接成功
                manDevMac:'',//当前设备加入的主路由mac
                devMac:'',//当前设备mac
                addMainDevStatus:{//子路由模式下加入主路由状态
                    status:false,// 是否加入成功
                    ip:''  //加入之后的IP
                },
                MainRouter:{},//主路由信息
                childDevicelist:[], //子路由列表
                isGetChildDev:false, //获取子路由设备请求状态
                timeOut:0,
                endGetSubDvelist:false,
                showNetMode:false,
                subDevNetMode:0, // 0=>有线 3=>无线
                subDevCache:[], // 已加入的子路由设备缓存
                addNewSubDev:[] // 主路由扫描新加入的子路由信息
            }
        },
        created(){
            this.getFilinkCfg()
        },
        beforeDestroy(){
            this.endGetSubDvelist = true
        },
        methods: {
            // 主路由模式下 定时获取子路信息
            initGetSubDvelist(){
                // 不是主路由模式  或者离开当前页面 或者显示topo信息时 不刷新 
                if(this.deviceType !== 1  || this.endGetSubDvelist || this.isTopoShow)
                    return
                
                setTimeout(()=>{
                    if(!this.isGetChildDev)
                    {
                        this.getChildDevicelist()
                        if(this.addDevice) addNewSub(this)                        
                    }
                        
                    this.initGetSubDvelist()
                },10000)
            },
            // 获取 当前设备主要信息 主/子路由模式 及Filink 开关
            getFilinkCfg(){
                axios
                .post("/boafrm/fhFilink",{
                    CmdType:"GET_FILINK_CFG",
                })
                .then((response)=>{
                    if(response.data.ret === 0)
                    {
                        this.deviceType = response.data.filink.filinkMode
                        this.FilinkEnabele = (response.data.filink.filinkMode > 2) ? false : true
                        this.devMac = response.data.filink.devMac.toUpperCase()
                        this.subDevConnect = response.data.filink.subDevConnect
                        this.subDevNetMode = response.data.filink.subDevNetMode
                        if(response.data.filink.subDevConnect)
                            this.manDevMac = response.data.filink.manDevMac.toUpperCase()
                        if(response.data.filink.filinkMode === 1)
                        {
                            this.getChildDevicelist()
                            this.initGetSubDvelist()
                        }
                            
                    }
                    else
                       this.$message.error(`GET data failed! Error:${response.data.errMsg}`)
                })
                .catch((error) => {
                     this.$message.error('GET data failed! Network connection error!')
                })
            },
            // 主路由模式下 获取子路由信息
            getChildDevicelist(){
                this.isGetChildDev = true
                axios
                .post("/boafrm/fhFilink",{
                    CmdType:"GET_SUBDEV_INFO",
                })
                .then((response)=>{
                    if(response.data.ret === 0)
                    {                    
                        this.topoD = response.data.subDevInfo
                        this.childDevicelist = [] 
                        response.data.subDevInfo.ChildRouter.forEach((e)=>{
                            if(Object.keys(e).length != 0) this.childDevicelist.push(e)
                        })
                        this.MainRouter = response.data.subDevInfo.MainRouter
                        if(this.deviceType === 2)
                        {//子路由模式
                            // 根据当前设备mac查找是否组网成功
                            this.childDevicelist.forEach(element => {
                                if(element.Mac === this.devMac)
                                {
                                    this.addMainDevStatus.status = true
                                    this.addMainDevStatus.ip = element.ip
                                }
                            });
                        }
                         
                    }
                    else
                    {
                        console.log(`GET data failed! Error:${response.data.errMsg}`)
                    }
                    this.isGetChildDev = false
                })
                .catch((error) => {
                    this.isGetChildDev = false
                    console.log('GET data failed! Network connection error!')
                })
            },
            // 设置 Filink 开关
            setFilinkEnabele(val){
                axios
                .post("/boafrm/fhFilink",{
                    CmdType:"SET_FILINK_CFG",
                    filinkMode:val ? 0 : 3
                })
                .then((response)=>{
                    if(response.data.ret === 0)
                    {
                        this.deviceType = 0
                        this.getFilinkCfg()
                        if(!val)
                        {   
                            // 更新全局状态 非桥模式
                            this.$G_DEVICE_CFG.isBridge = false
                            devConfig.update(this.$G_DEVICE_CFG)
                        }
                        this.$message.success("Configuration is successful!！")
                    }
                    else
                       this.$message.error(`Configuration failed! Error:${response.data.errMsg}`)
                })
                .catch((error) => {
                    this.$message.error('SET data failed! Network connection error!')
                })
                
            },
            // 把设备设置为主路由模式
            setMainDec(){
                axios
                .post("/boafrm/fhFilink",{
                    CmdType:"SET_FILINK_CFG",
                    filinkMode:1
                })
                .then((response)=>{
                    if(response.data.ret === 0)
                    {
                        this.deviceType = 1
                        this.getChildDevicelist()
                        this.$message.success("Configuration is successful!The device is configured for main routing mode!")
                    }
                    else
                       this.$message.error(`Configuration failed! Error:${response.data.errMsg}`)
                })
                .catch((error) => {
                    this.$message.error('SET data failed! Network connection error!')
                })
            },
            // 把设备设置为子路由模式
            setSubDec(){
                axios
                .post("/boafrm/fhFilink",{
                    CmdType:"SET_FILINK_CFG",
                    filinkMode:2
                })
                .then((response)=>{
                    if(response.data.ret === 0)
                    {
                        this.deviceType = 2
                        this.$message.success("Configuration is successful!The device is configured for sub-routing mode!")
                    }
                    else
                       this.$message.error(`Configuration failed! Error:${response.data.errMsg}`)
                })
                .catch((error) => {
                    this.$message.error('SET data failed! Network connection error!')
                })
            },
            // 查询添加子路由信息定时器
            checkAddSubDev(){
                // 关闭弹窗 结束
                if(!this.addDevice)
                    return
                // 超时检查 5min
                if(this.timeOut > 150)
                {
                    this.addLoading = false
                    if(this.childDevicelist.length)
                        this.addRetText = `The Filink network is completed, and ${this.childDevicelist.length} sub-routing devices are found.`
                    else
                        this.addRetText = 'No available sub-routing devices detected'
                    return
                }

                
                setTimeout(()=>{
                    this.timeOut++
                    this.checkAddSubDev()
                },2000)

            },
            // 添加子路由
            addChildDevice() {
                this.addDevice = true
                this.addLoading = true
                this.addLoadText = 'Waiting for device access...'
                this.addRetText = ''
                this.subDevCache = JSON.parse( JSON.stringify( this.childDevicelist ) )
                this.addNewSubDev = []

                axios
                .post("/boafrm/fhFilink",{
                    CmdType:"START_FILINK_MAINDEV",
                })
                .then((response)=>{
                    if(response.data.ret === 0)
                    {
                        this.timeOut = 0
                        this.initGetSubDvelist()
                        this.checkAddSubDev()
                    }
                    else
                    {
                        this.addLoading = false
                        this.addRetText = `Adding a sub-routing device failed! Error:${response.data.errMsg}`
                    }
                })
                .catch((error) => {
                    this.addLoading = false
                    this.addRetText = 'Adding a sub-routing device failed! Network connection error!'
                })
            },
            // 检查连接主路由状态
            checkAddMainDev(){
                // 关闭弹窗 结束
                if(!this.addMainDialog)
                    return
                //如果加入成功
                if(this.addMainDevStatus.status)
                {
                    this.addLoading = false
                    return
                }
                    
                // 超时检查 5min
                if(this.timeOut > 150)
                {
                    this.addLoading = false
                    this.addRetText = 'Filink networking timeout!'
                    return
                }

                setTimeout(()=>{
                    if(!this.isGetChildDev)
                        this.getChildDevicelist()
                    this.timeOut++
                    this.checkAddMainDev()
                },2000)

            },
            // 加入主路由弹窗 关闭按钮
            addMainDevClose(done){
                done()
                if(this.addMainDevStatus.status)
                {
                    cookie.clear();
                    window.location.href = `http://${this.addMainDevStatus.ip}`
                }
                    
            },
            // 加入主路由弹窗 取消按钮
            addMainDevCancel(){
                this.addMainDialog = false
                if(this.addMainDevStatus.status)
                {
                    cookie.clear();
                    window.location.href = `http://${this.addMainDevStatus.ip}`
                }
            },
            // 加入主路由弹窗 完成按钮
            addMainDevConfirm(){
                this.addMainDialog = false 
                if(this.addMainDevStatus.status)
                {
                    cookie.clear();
                    window.location.href = `http://${this.addMainDevStatus.ip}`
                }
            },
            // 加入主路由
            addMainDevice(mode){
                const modeCache = this.subDevNetMode
                this.subDevNetMode = mode
                this.addMainDialog = true
                this.addLoading = true
                this.addRetText = ''

                this.addMainDevStatus.status = false
                this.addMainDevStatus.ip = ''
                axios
                .post("/boafrm/fhFilink",{
                    CmdType:"START_FILINK_SUBDEV",
                    subDevNetMode:mode
                })
                .then((response)=>{
                    if(response.data.ret === 0)
                    {
                        this.checkAddMainDev()

                        // 更新全局状态 桥模式
                        this.$G_DEVICE_CFG.isBridge = true
                        devConfig.update(this.$G_DEVICE_CFG)
                    }
                    else
                    {
                        this.subDevNetMode = modeCache
                        this.addLoading = false
                        this.addRetText = `Failed to connect to the main routing device! Error:${response.data.errMsg}`
                    }
                })
                .catch((error) => {
                    this.subDevNetMode = modeCache
                    this.addLoading = false
                    this.addRetText = 'Failed to connect to the main routing device!Network connection error!'
                })
            },
            //  选择子路由组网方式
            chooseSubNetMode(mode){
                this.showNetMode = false
                axios
                .post("/boafrm/fhFilink",{
                    CmdType:"GET_WANLINK_STATUS"
                })
                .then((response)=>{
                    if(response.data.ret === 0)
                    {
                        if(response.data.wanLinkStatus && mode === 3)
                        {
                            this.$alert('For wireless networking, unplug the WAN port cable!', 'Warning', {
                                confirmButtonText: 'Confirm',
                                type: 'warning'
                            })
                        }
                        else
                        {
                            setTimeout(()=>{
                                this.addMainDevice(mode)
                            },500)
                        }
                            
                    }
                    else
                    {
                        this.$message.error('Get GET_WANLINK_STATUS faild!')
                    }
                })
                .catch((error) => {
                    this.$message.error('Get GET_WANLINK_STATUS faild!Network connection error!')
                })
            },
            closeTopoDialog(){
                this.isTopoShow = false
                this.initGetSubDvelist()
            },
            //字节单位换算
            byteToKbOrMb(byte){
                byte = byte * 8
                const k = 1024
                const m = 1048576
                let speed = 0.00
                if(byte > m)
                {
                     speed = (byte / m).toFixed(1)
                     return `${speed} Mbps`
                }
                else if(byte > k && byte < m)
                {
                    speed = (byte / k).toFixed(1)
                    return `${speed} Kbps`
                }
                else if(byte > 0 && byte < k)
                {
                    return `${byte} bps`
                }
                else
                {
                    return '0.0 bps'
                }
            }
        },
    }

/**
 * 比较 获取的子路由列表数据和缓存数据，找出新增的子路由
 */
function addNewSub(vm) {
    let a = vm.childDevicelist.map(x => {return JSON.stringify({ip:x.ip,Mac:x.Mac})})
    let b = vm.subDevCache.map(x => {return JSON.stringify({ip:x.ip,Mac:x.Mac})})
    vm.addNewSubDev =  a.concat(b).filter(v => !a.includes(v) || !b.includes(v)).map(x => JSON.parse(x))
}

</script>
<style src="@/assets/style/filink.scss" lang="scss"></style>